import { PREDEFINED_COUNTRY_CODES } from '../../constants';

type IsoCode = keyof typeof PREDEFINED_COUNTRY_CODES;

const getMaskByIsoCode = (value: IsoCode): string | undefined =>
  PREDEFINED_COUNTRY_CODES[value];

export default getMaskByIsoCode;
